import { useCallback } from "react";
import { FormProvider } from "react-hook-form";
import { Color, MagnifyingGlassIcon, TextFieldController } from "@bonliva-crm/ui";
import { Box, Divider, Typography, makeStyles, Fab } from "@material-ui/core";
import { useGlobalStore } from "@hooks";
import { Flight } from "@material-ui/icons";
import { WithTooltip } from "@common";
import locale from "@bonliva-crm/locale";
import { useTravelRequestSearchFilters } from "./hooks/use-travel-request-search-filters";
import { SearchProfileType } from "@bonliva-crm/graphql";
import { FilterSlider } from "@bonliva-crm/ui/search-filters";
import { FavouriteFilter } from "@bonliva-crm/ui/search-filters";
import { TravelRequestTable } from "./components/travel-request-table/travel-request-table";
import { TravelRequestLocation } from "@bookings/BookingHospitality/locations/TravelRequestLocation";

export const TravelRequestSearchLayout = () => {
  const classes = useStyles();

  const { filterManager } = useTravelRequestSearchFilters();
  const { navigation } = useGlobalStore();

  const handleCreateTravelRequest = useCallback(() => {
    navigation.open("travel_request", new TravelRequestLocation({}));
  }, []);

  return (
    <FormProvider {...filterManager.formMethods}>
      <Box className={classes.root}>
        <Box className={classes.flexColumn}>
          <Box className={classes.flexRow} style={{ justifyContent: "space-between" }}>
            <Typography variant="h2">{locale.mainMenu.travelRequests}</Typography>
            <TextFieldController
              name="text"
              textFieldProps={{
                className: classes.searchField,
                placeholder: locale.Search,
                inputProps: { autoComplete: "off" },
                InputProps: {
                  startAdornment: <MagnifyingGlassIcon />,
                  style: { borderColor: Color.DarkGray }
                }
              }}
            />
            <WithTooltip title={locale.newTravelRequest}>
              <Fab color="primary" onClick={handleCreateTravelRequest} size="small">
                <Flight />
              </Fab>
            </WithTooltip>
          </Box>
          <FavouriteFilter
            filterManager={filterManager}
            searchProfileType={SearchProfileType.TravelRequests}
          />
          <Divider />
          <TravelRequestTable />
        </Box>
        <FilterSlider
          sortByLabel
          filterManager={filterManager}
          searchProfileType={SearchProfileType.TravelRequests}
        />
      </Box>
    </FormProvider>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 4, 5.2, 2),
    height: "100%"
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    height: "100%"
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2)
  },
  searchField: {
    width: "60%"
  },
  allFilters: {
    padding: "0 1rem",
    border: `1px solid ${Color.LightGray}`,
    height: "2.5rem",
    borderRadius: "0.375rem",
    width: "125px",
    "&:hover": {
      cursor: "pointer"
    }
  }
}));
